import mirrorKey from 'mirrorkey'

const busEvents = mirrorKey({
  SESSION_EXPIRED: null,
})

export default busEvents